import { BankMarketType } from "@modules/+new/payments/features/fiat-deposit/domain/entities/bank/bank-market-type.enum";
import { Logo } from "@modules/+new/payments/shared-payments/entities/logo.model";
import { BaseAdapter } from "@modules/+new/payments/shared-payments/entities/base-adapter";
import { BankDto } from "@modules/+new/payments/features/fiat-deposit/infrastructure/dto/bank.dto";

export interface Bank {
	readonly id: string;
	readonly parentId: string;
	readonly isLeaf: boolean;
	readonly isMoneyAdvanceSupported: boolean;
	logo: Logo;
	readonly market: BankMarketType;
	readonly name: string;
}

export class BankAdapter extends BaseAdapter<BankDto, Bank> {
	public adapt(item: BankDto): Bank | null {
		if (!item) {
			return null;
		}

		return {
			id: item.id,
			parentId: item.parent_id,
			isLeaf: item.is_leaf,
			isMoneyAdvanceSupported: item.is_money_advance_supported,
			logo: {
				defaultUrl: item.logo,
				darkUrl: item.logo_dark
			},
			market: <BankMarketType>item.market,
			name: item.name
		};
	}
}
